<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "App",
  components: {},
  metaInfo() {
    return {
      meta: this.$route.meta.metaInfo,
    };
  },
  data() {
    return {};
  },
  mounted() {
    this.resize();

    const recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://www.google.com/recaptcha/api.js"
    );
    document.head.appendChild(recaptchaScript);
  },
  methods: {
    resize() {
      window.addEventListener("DOMContentLoaded", function () {
        if (screen.width < 375) {
          let viewport = document.getElementById("viewport");
          viewport.setAttribute(
            "content",
            "width=375, maximum-scale=1, user-scalable=no"
          );
        }
      });

      window.addEventListener("resize", function () {
        let viewport = document.getElementById("viewport");

        if (screen.width < 375) {
          viewport.setAttribute(
            "content",
            "width=375, maximum-scale=1, user-scalable=no"
          );
        } else {
          viewport.setAttribute(
            "content",
            "width=device-width, initial-scale=1.0, maximum-scale=1, user-scalable=no"
          );
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "src/assets/style/reset.scss";
@import "src/assets/style/common.scss";
@import "src/assets/style/style.scss";

#app {
  width: 100%;
  word-break: keep-all;
}

.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(24, 24, 24, 0.1);
  z-index: 0;
  display: none;
}
</style>
